import {
  createRouter,
  createWebHistory
} from 'vue-router'
import Login from '../views/Login.vue'
import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'
import {
  system
} from '@/router/system'
import {
  tenant
} from '@/router/tenant'
import {
  approval
} from '@/router/approval'
// import { lowcode } from '@/router/lowcode'
import {
  baseManage
} from '@/router/baseManage'
import {
  warehouseManagement
} from '@/router/warehouseManagement'
import {
  inv
} from '@/router/inv'
import {
  noticeManage
} from '@/router/noticeManage'
import {
  actions
} from '@/globalState'
import {
  repairManage
} from '@/router/repairManage'
import {
  faultModule
} from '@/router/faultModule'


// 路由注册
export const routes = [{
  path: '/',
  name: 'login',
  component: Login,
  meta: {
    title: '登录',
    disableTabMode: true
  }
},
{
  path: '/bpmToSfterSales',
  name: 'bpmToSfterSales',
  component: () => import('@/views/faultModule/faultOpen/bpmToSfterSales.vue'),
  meta: {
    title: 'bmp跳转'
  }
},
{
  path: '/login',
  redirect: '/'
},

/**
 *  首页、模板页面、404 等公共页面
 */
{
  path: '/layout',
  redirect: 'home',
  component: LayoutWithSideMenu,
  meta: {
    title: '首页'
  },
  children: [{
    path: 'home',
    name: 'home',
    component: () => import('@/views/home'),
    meta: {
      title: '首页'
    }
  },
  {
    path: 'personCenter',
    name: 'personCenter',
    component: () => import('@/views/system/personCenter'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: 'notification',
    name: 'notification',
    component: () => import('@/views/system/notification'),
    meta: {
      title: '消息通知'
    }
  },
  /*
   * 根据注册的子应用动态创建路由，后面内容无需更改
   */
  ...(window.appConfig.map(item => ({
    path: item.activeRule + '/:pathMatch(.*)*',
    name: item.name,
    component: () => import('@/views/portal'),
    props: {
      ...item.props,
      actions: actions
    },
    meta: {
      title: item.title
    }
  }))), // 结束插入
  {
    path: '404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      title: '404'
    }
  }
  ]
},

  /**
   * 系统模块部分
   */
  system,

  /**
   * 租户模块部分
   */
  tenant,

  /**
   * 审批管理系统模块
   */
  approval,
  /**
   * 低代码模块
   */
  // ...lowcode,


  //仓储模块部分
  warehouseManagement,
  // 基础管理
  baseManage,
  //通知管理
  noticeManage,
  inv,
  // 维保管理
  repairManage,
  // 故障模块
  faultModule,
/**
 * 通配符
 */
{
  path: '/:catchAll(.*)',
  name: 'redirectTo404',
  redirect: '/layout/404'
}
]

export default createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes
})
